import React, { FC } from 'react';

import ContentBlockHeader from './ContentBlockHeader';
import PdfSections from '../sections/PdfSections';
import { SelectListProvider } from '../../../../components/context/SelectListContext';

import { PDF_OPTIONS_TEXT } from '../../../../services/constants';

import { PdfSettingOptions, PdfSettingsLayout } from '../../../../types/enums';

import useStyles from '../style';

const TimelineLayoutContent: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.contentBlock} data-spy-id={PdfSettingOptions.timelineLayout}>
      <SelectListProvider>
        <ContentBlockHeader
          name={PDF_OPTIONS_TEXT[PdfSettingOptions.timelineLayout]}
          subFieldName={PdfSettingsLayout.timeline}
          inputName="withTimeline"
        />
        <PdfSections layout={PdfSettingsLayout.timeline} />
      </SelectListProvider>
    </div>
  );
};

export default TimelineLayoutContent;
